import formatDate from 'date-fns/format'

import { useDataChange, useDataValue } from 'Simple/Data.js'
import { useSetFlowTo, normalizePath, useFlowValue } from 'Simple/Flow.js'

export function getLabel(due_date) {
  if (!due_date?.from || !due_date?.to) {
    return 'Due date'
  } else {
    return `${formatDate(due_date.from, 'MM/dd/yyyy')} - ${formatDate(
      due_date.to,
      'MM/dd/yyyy'
    )}`
  }
}

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let flow = useFlowValue(props.viewPath)

  let change = useDataChange({
    context: 'filters',
    path: 'due_date',
    viewPath: props.viewPath,
  })

  let due_date = useDataValue({
    context: 'filters',
    path: 'due_date',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (due_date) {
      change(null)
      return
    }

    if (flow === 'Content') {
      setFlowTo(normalizePath(props.viewPath, 'No'))
      return
    }

    setFlowTo(normalizePath(props.viewPath, 'Content'))
  }
}
